/**
 * Returns the error followed by each nested `cause` (React error boundaries and Sentry wrap the
 * original error this way), stopping at the first non-object value or cycle.
 */
export function getErrorCauseChain(error: unknown): object[] {
  const chain: object[] = []
  let currentError = error

  while (
    currentError &&
    (typeof currentError === 'object' || typeof currentError === 'function') &&
    !chain.includes(currentError)
  ) {
    chain.push(currentError)
    currentError = 'cause' in currentError ? currentError.cause : undefined
  }

  return chain
}
